import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MoreIcon from '@rsuite/icons/More';
import { Icon } from '@rsuite/icons';
import SortDownIcon from '@rsuite/icons/SortDown';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import AttachmentIcon from '@rsuite/icons/Attachment';
import CopyIcon from '@rsuite/icons/Copy';
import TrashIcon from '@rsuite/icons/Trash';
import ReviewRefuseIcon from '@rsuite/icons/ReviewRefuse';
import TagIcon from '@rsuite/icons/Tag';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import CheckIcon from '@rsuite/icons/Check';
import pptxgen from "pptxgenjs";
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  FlexboxGrid,
  Container,
  Modal,
  SelectPicker,
  IconButton,
  Table,
  ButtonToolbar,
  Whisper,
  Popover,
  Dropdown,
  ButtonGroup,
  Tooltip,
  Carousel,
  Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { mockUsers } from '@/data/mock';
import AdminIcon from '@rsuite/icons/Admin';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import EditIcon from '@rsuite/icons/Edit';


const { Column, HeaderCell, Cell } = Table;
const data1 = mockUsers(100);
const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  return (
    <Cell {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <input
          className="rs-input"
          defaultValue={rowData[dataKey]}
          onChange={event => {
            onChange && onChange(rowData.id, dataKey, event.target.value);
          }}
        />
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Cell>
  );
};

const ActionCell1 = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Stack spacing={5}>
        <Button
          appearance="subtle"
          active
          onClick={() => {
            onClick(rowData.id);
          }}
        >
          {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
        </Button>
        <Button
          appearance="subtle" active
        > View</Button>
        <Whisper followCursor speaker={<Tooltip>Discontinue</Tooltip>}>
          <IconButton icon={<TrashIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );
};

const ManageCollection = () => {

// Download PPT Start

const [imageData, setImageData] = useState('');
const [imageData1, setImageData1] = useState('');

  const generatePresentation = () => {
    const pptx = new pptxgen();
    const slide = pptx.addSlide();
    const slide1 = pptx.addSlide();
    const slide2 = pptx.addSlide();

    // Add the image to the slide
    slide.addImage({ data: imageData, x: 0.5, y: 0.5, w: 2, h: 4 });
    slide.addImage({ data: imageData1, x: 3, y: 1, w: 2, h: 4 });

    slide1.addImage({ data: imageData, x: 0.5, y: 0.5, w: 2, h: 4 });
    slide1.addImage({ data: imageData1, x: 3, y: 1, w: 2, h: 4 });

    slide2.addImage({ data: imageData, x: 0.5, y: 0.5, w: 2, h: 4 });
    slide2.addImage({ data: imageData1, x: 3, y: 1, w: 2, h: 4 });
    
    pptx.writeFile();
  };

  const setImageDataFromUrl = (imageUrl) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onload = () => {
        setImageData(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.send();
  };

  const imageUrl = 'http://b2bportal:3100/src/assets/images/items/img1.jpg';
  setImageDataFromUrl(imageUrl);


  const setImageDataFromUrl1 = (imageUrl1) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageUrl1, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onload = () => {
        setImageData1(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.send();
  };

  const imageUrl1 = 'http://b2bportal:3100/src/assets/images/items/img2.jpg';
  setImageDataFromUrl1(imageUrl1);
// Download PPT End


  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [loading, setLoading] = React.useState(false);



  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const Buyer1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <FormControlLabel>---</FormControlLabel>
    </Cell>
  );

  const Active = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="ghost" active color='cyan'
      > Active</Button>
    </Cell>
  );
  const Catalogue = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <b>Summer Collection for 2022</b>
      <p>6 Products</p>
      <p>Generated by erpdaddy.com Monday at 2:30 PM </p>
    </Cell>
  );
  const Active1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="subtle" active color='orange'
      > Draft</Button>
    </Cell>
  );
  const renderMenu1 = ({ onClose, left, top, className }, ref) => {
    const handleSelect = eventKey => {
      onClose();
      console.log(eventKey);
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1} onClick={generatePresentation}>Download PPT<Icon as={SortDownIcon} /></Dropdown.Item>
          <Dropdown.Item eventKey={2}>Download Excel <Icon as={SortDownIcon} /></Dropdown.Item>

        </Dropdown.Menu>
      </Popover>
    );
  };
  const renderMenu = ({ onClose, left, top, className }, ref) => {
    const handleSelect = eventKey => {
      onClose();
      console.log(eventKey);
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect} >
          <Dropdown.Item ><Stack justifyContent='space-between' ><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TagIcon} /><Stack direction='column' alignItems='flex-start'><b>Create Quotation</b><p>You can maintain a list of all quotation </p><p> generated angaist buyer</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={ReviewRefuseIcon} /><Stack direction='column' alignItems='flex-start'><b>Deactivate Catalogue Link</b><p>Link will be deactivated and you can </p><p>activate it again later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between' spacing={10}><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={AttachmentIcon} /><Stack direction='column' alignItems='flex-start'><b>Updata Link Settings</b><p>Change settings for passsword security</p> <p>and expiry date</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={CopyIcon} /><Stack direction='column' alignItems='flex-start'><b>Creae a copy of this catalogue</b><p>A copy of this catalogue will be </p><p> created with same products</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TrashIcon} /><Stack direction='column' alignItems='flex-start'><b>Delete this catalogue</b><p>Permanantly delete this catalogue </p> <p> you cannot restore them later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="link-group">
        <Whisper placement="auto" trigger="click" speaker={renderMenu}>
          <IconButton appearance="subtle" style={{ marginTop: '-8px' }} active icon={<MoreIcon />} />
        </Whisper>
      </Cell>
    );
  };
  const Controls = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Link to='/editCollection'>
          <Button
            appearance="subtle" active
          > Edit</Button>
        </Link>
        <Link to="/viewCollection">
          <Button
            appearance="subtle" active
          > View</Button>
        </Link>
        <Whisper followCursor speaker={<Tooltip>Discontinue</Tooltip>}>
          <IconButton icon={<TrashIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );
  const Controls1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu1}>
          <IconButton icon={<EditIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );


  const [showtab, setShowtab] = useState(1);

  const [searchKeyword, setSearchKeyword] = useState('');

  const buyer = ['All Collection'].map(
    item => ({ label: item, value: item })
  );

  const [selectedOption, setSelectedOption] = useState('Option 1');

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handletab = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (x?.click) {
      x.hidden = true
    }
    if (x?.click) {
      y.hidden = false
    }

  };
  const handletab2 = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (y?.click) {
      y.hidden = true
    }
    if (y?.click) {
      x.hidden = false
    }
  };

  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);

  const handleClick1 = () => {

    handletab(2)
    setIsActive1(!isActive1);
    setIsActive2(false);
  }
  const handleClick2 = () => {

    handletab2(1)
    setIsActive1(isActive2);
    setIsActive2(true);

  };
  const tooltip = (
    <Tooltip>
      List View
    </Tooltip>
  );
  const tooltip1 = (
    <Tooltip>
      Grid View
    </Tooltip>
  );

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };

  const data = data1.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const [dataa, setDataa] = React.useState(data1);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], dataa);
    nextData.find(item => item.id === id)[key] = value;
    setDataa(nextData);
  };
  const handleEditState = id => {
    const nextData = Object.assign([], dataa);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setDataa(nextData);
  };


  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Manage Collection</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Collection</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} >
              <Stack direction='column' alignItems='flex-start' >
                <label>Collection Name</label>
                <SelectPicker data={buyer} size="xs" appearance="default" placeholder="Collection Name" style={{ width: 200 }} />
              </Stack>

              <Stack direction='column' alignItems='flex-start' >
                <label>Status</label>
                <SelectPicker value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues (966)', value: 'Option 1' },
                    { label: 'Draft (183)', value: 'Option 2' },
                    { label: 'Active (755)', value: 'Option 3' },
                    { label: 'Inactive (28)', value: 'Option 4' }
                  ]} size="xs" appearance="default" placeholder="Status" style={{ width: 150 }} />
              </Stack>

              <IconButton size="md" icon={<SearchIcon />} style={{ marginTop: '20px' }} active />
            </Stack>
          </Stack>


          <Stack direction='column' alignItems='flex-end' spacing={44}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack >
              <ButtonToolbar>
                <ButtonGroup size="md">
                  <Whisper placement="bottomEnd" controlId="control-id-hover" trigger="hover" speaker={tooltip}>
                    <IconButton icon={<MenuIcon />} active={isActive1} className={showtab === 2 ? "btn btn-outline-secondary" : "btn btn-outline-secondary"} onClick={handleClick1} id="ba" />
                  </Whisper>
                  <Whisper placement="bottomEnd" controlId="control-id-hover" trigger="hover" speaker={tooltip1}>
                    <IconButton icon={<GridIcon />} active={isActive2} className={showtab === 1 ? "btn btn-outline-secondary " : "btn btn-outline-secondary "} onClick={handleClick2} id="bb" />
                  </Whisper>
                </ButtonGroup>
              </ButtonToolbar>
            </Stack>
          </Stack>
        </Stack>

        <Divider className='divide' />

        <div className={showtab === 1 ? 'row' : ''} id="row">
          <Panel>
            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" >
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 5
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" >
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 7
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img1.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 6
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" >
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img11.jpg" height="250" />
                      <img src="../src/assets/images/items/img10.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img14.jpg" height="250" />
                      <img src="../src/assets/images/items/img6.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 8
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" >
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img1.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 2
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" >
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 3
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img1.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 5
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img6.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 4
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img1.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img6.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 9
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 5
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img9.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 7
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img8.jpg" height="250" />
                      <img src="../src/assets/images/items/img2.jpg" height="250" />
                      <img src="../src/assets/images/items/img3.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 6
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3">
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Carousel autoplay shape='bar' className="custom-slider imgp">
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                      <img src="../src/assets/images/items/img4.jpg" height="250" />
                      <img src="../src/assets/images/items/img1.jpg" height="250" />
                      <img src="../src/assets/images/items/img5.jpg" height="250" />
                      <img src="../src/assets/images/items/img7.jpg" height="250" />
                    </Carousel>
                    {/* <div className="overlay">Collection Veiw</div> */}
                    <Panel header="Collection Name : T-Shirt">
                      <p>
                        <small>
                          Total Products : 5
                        </small>
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Panel>
        </div>
        <div className={showtab === 2 ? "tableform" : ""} id='second' hidden>
          
            {selectedOption === 'Option 1' && (
              <Table height={420}
                data={getData()}
                rowHeight={100}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={loading} id="table">

                <Column width={80} align="center" sortable>
                  <HeaderCell>S.No.</HeaderCell>
                  <Cell dataKey="id" />
                </Column>

                <Column width={300} align="center">
                  <HeaderCell>Collection Name</HeaderCell>
                  <EditableCell dataKey="name" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
                </Column>

                <Column width={130}>
                  <HeaderCell>Total Products</HeaderCell>
                  <EditableCell dataKey="age" onChange={handleChange} rowData={undefined} />
                </Column>

                <Column width={130}>
                  <HeaderCell>Date Of Creation</HeaderCell>
                  <EditableCell dataKey="date" onChange={handleChange} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell>Created By</HeaderCell>
                  <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
                </Column>

                <Column width={150}>
                  <HeaderCell>Remark</HeaderCell>
                  <EditableCell dataKey="id" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
                </Column>

                <Column width={150}>
                  <HeaderCell>Activity</HeaderCell>
                  <EditableCell dataKey="id" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell>Action</HeaderCell>
                  <Controls dataKey="id" rowData={undefined} expandedRowKeys={undefined} onChange={undefined} />
                </Column>
              </Table>
            )}
            {selectedOption === 'Option 2' && (
              <Table height={420}
              rowHeight={100}
                data={getData()}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={loading} id="table">

                <Column width={400} align="center" sortable>
                  <HeaderCell>Catalogue Details</HeaderCell>
                  <Catalogue dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell>Status</HeaderCell>
                  <Active1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell>Buyer Details</HeaderCell>
                  <Cell dataKey="name" />
                </Column>

                <Column width={250}>
                  <HeaderCell>Buyer Activity</HeaderCell>
                  <Buyer1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell>Controls</HeaderCell>
                  <Controls1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={50}>
                  <HeaderCell>

                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column>

              </Table>
            )}
            <Stack justifyContent='flex-end'><Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={['total', '-', 'limit', '|', 'pager', 'skip']}
              total={data1.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            /></Stack>
          
        </div>

        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>

      </Container>
    </>
  );
};

export default ManageCollection;